<div class="change-step-action-selection-dialog">
  <h2 mat-dialog-title>
    {{ 'workInstructionStepper.changeStepActionSelectionDialog.title' | translate }}
  </h2>
  <form [formGroup]="formGroup" (ngSubmit)="onFormDialogSubmit()">
    <div mat-dialog-content>
      <mat-radio-group class="radio-group" formControlName="selectedAction">
        @if (data.isSaveAndCompleteOptionDisabled) {
          <div class="mb-2">
            <mat-icon class="v-middle me-1 material-icons-outlined">info</mat-icon
            >{{ 'workInstructionStepper.changeStepActionSelectionDialog.information' | translate }}
          </div>
        }
        <mat-radio-button [disabled]="data.isSaveAndCompleteOptionDisabled" [value]="'saveAndComplete'"
          >{{ 'workInstructionStepper.changeStepActionSelectionDialog.choice.saveAndComplete' | translate }}
        </mat-radio-button>
        <mat-radio-button [value]="'justSave'">{{
          'workInstructionStepper.changeStepActionSelectionDialog.choice.justSave' | translate
        }}</mat-radio-button>
      </mat-radio-group>
    </div>
    <mat-dialog-actions align="end">
      <button matButton="tonal" mat-dialog-close>{{ 'button.cancel' | translate }}</button>
      <button mat-flat-button type="submit">
        {{ 'button.next' | translate }}
      </button>
    </mat-dialog-actions>
  </form>
</div>
